import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NewReceiptImageComponent } from '@components/new-receipt/new-receipt-image/new-receipt-image.component';
import { BehaviorSubject, tap } from 'rxjs';
import { StoreService } from './store.service';

@Injectable({
	providedIn: 'root',
})
export class ImageUploadService {
	private _ss = inject(StoreService);
	private http = inject(HttpClient);
	private dialog = inject(MatDialog);
	private readonly path = 'mobil/upload/image';

	imageUploadingQueue$ = new BehaviorSubject<Array<string>>([]);
	uploadedImages$ = new BehaviorSubject<Array<string>>([]);

	constructor() {}

	uploadImageToServer(file: File) {
		if (!file) {
			throw new Error('no file');
		}
		const endpoint = `${this._ss.CustomerInformation.CustServer}/${this.path}`;
		const formData = new FormData();
		formData.append('file', file);
		this.imageUploadingQueue$.next([...this.imageUploadingQueue$.value, file.name]);
		return this.http.post(`${endpoint}`, formData).pipe(
			tap(() => {
				const currentValue = this.imageUploadingQueue$.getValue();
				this.imageUploadingQueue$.next(currentValue.filter(name => name !== file.name));
			}),
		);
	}

	addImageToUploadedImages(imageName: string) {
		this.uploadedImages$.next([...this.uploadedImages$.value, imageName]);
	}

	resetImages() {
		this.uploadedImages$.next([]);
		this.imageUploadingQueue$.next([]);
	}

	openImageDialogAndAwaitUserInteraction(imagePrefix: string): Promise<void> {
		const dialogRef = this.dialog.open(NewReceiptImageComponent, {
			disableClose: true,
			data: { prefix: imagePrefix },
		});

		return new Promise<void>(resolve => {
			dialogRef.afterClosed().subscribe(() => {
				resolve();
			});
		});
	}

	/*
		private handleCustomAlert(alert: Alert[] | string | string[], options?: { confirmAction?: boolean; confirmActionWithoutCancel?: boolean; disableBackdropClick?: boolean }) {
		if (typeof alert === 'string') {
			alert = [{ ...dummyAlert, Msg: alert }] as Alert[];
		}

		if (Array.isArray(alert) && typeof alert[0] === 'string') {
			alert = alert.map(msg => ({ ...dummyAlert, Msg: msg }));
		}

		const dialogRef = this.dialog.open(AlertDialogComponent, {
			width: '250px',
			data: { alerts: alert, ...options },
			disableClose: options?.disableBackdropClick,
		});

		if (!options?.confirmAction) return null;

		return new Promise<boolean>(resolve => {
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}
	*/
}
